function decimalAdjust(type, value, exp) {
  // Если степень не определена, либо равна нулю...
  if (typeof exp === "undefined" || +exp === 0) {
    return Math[type](value);
  }
  value = +value;
  exp = +exp;
  // Если значение не является числом, либо степень не является целым числом...
  if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
    return NaN;
  }
  // Сдвиг разрядов
  value = value.toString().split("e");
  value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
  // Обратный сдвиг
  value = value.toString().split("e");
  return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
}

// Десятичное округление к ближайшему
if (!Math.round10) {
  Math.round10 = function (value, exp) {
    return decimalAdjust("round", value, exp);
  };
}

export function usd(_usd, _precision) {
  if (_usd && _usd.toString().includes("e")) {
    // if a number is in exponential notation?
    return _usd;
  } else {
    //return val ? val.toFixed(precision) : "";
    _usd = Math.round10(_usd, -_precision); // Без этой строки не округляет числа с большим числом знаков после запятой
    return _usd
      ? _usd.toLocaleString("en-US", { maximumFractionDigits: _precision })
      : "";
  }
}

export const numOr0 = (n) => (isNaN(n) ? 0 : n);
